export enum CoreTransferStatus {
  Pending = 'pending',
  Triage = 'triage',
  Rejected = 'rejected',
  Complete = 'completed',
}
